import type { ContentReaction } from 'dfx/edge/edge.did';
import type { ReactionType } from '../types';

export const contentReactionToReactionType = (
  content: ContentReaction,
): ReactionType | undefined => {
  const keys = Object.keys(content);
  return keys.length > 0 ? (keys[0].toLowerCase() as ReactionType) : undefined;
};
